import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { checkStatus } from '../../../util/util';
import Select from 'react-select';
import map from 'lodash/map';
import filter from 'lodash/filter';
import { AlertBar, AlertConfirm, Alert, AlertCommit } from '../../Modals/AlertBar';

class MaintenanceTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            maintenanceInfoList: [],
            selectedDevice: '',
            carLicenceNo: '',
            selectedTemplate: '',

            device_id: 0,
            device_no: '',
            maList: {
                ma_name: '',
                measure_type_id: 4,
                alert_repeat: 0,
                is_email_alert: false,
                is_line_alert: false,
                counter: 0,
                next_alert_when: '',
                ma_list_id: ''
            },
            measureTypeList: [],
            deviceNoList: [],
            measureUnit: 'วัน',
            maListOnClick: [],
            alertHistory: [],
            isSaveTemplate: false,
            templateName: '',
            templateList: []
        }
    }

    componentWillMount() {
        const { isAddAlertMA } = this.props;
        this.setState({ isAddAlertMA });
    }

    componentDidMount(){
        this.getMAMeasureTypeList();
        this.getMATemplateList();
    }

    getMATemplateList = () => {
        const { user_id, user_name, token } = this.props;
        fetch('http://203.150.199.244/api/admin/getMATemplateList', {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({"filter": ''})
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                let objList = [];
                data.RESULT_DATA.map((obj, key) => {
                    objList.push({
                        name: obj.name,
                        template_id: obj.template_id,
                        ma_list: obj.ma_list
                    });
                });
                this.setState({templateList: objList});
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    getMAMeasureTypeList = () => {
        const { user_id, user_name, token } = this.props;
        fetch('http://203.150.199.244/api/admin/getMAMeasureTypeList', {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({})
        })
            .then(response => { return checkStatus(response)})
            .then(data => {
                let objList = [];
                data.RESULT_DATA.map((obj, key) => {
                    objList.push({
                        measure_type_id: obj.measure_type_id,
                        measureTypeName: obj.measure_type,
                        measureUnit: obj.measure_unit
                    });
                });
                this.setMeasureList(objList);

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }


    setDeviceList = (objList) => {
        this.setState({ deviceNoList: objList });
    }

    setMeasureList = (objList) => {
        this.setState({ measureTypeList: objList });
    }

    handleChange = (selectedDevice) => {
        this.setState({ selectedDevice });
    }

    handleChangeTemplate = (selectedTemplate) => {
        this.setState({ selectedTemplate });
    }

    onClickSearchDeviceNo = (selectedDevice) => {
        const {
            user_name,
            user_id,
            token
        } = this.props;

        this.setState({
            carLicenceNo: selectedDevice.label,
            device_no: selectedDevice.value
        });

        fetch(`http://203.150.199.244/api/admin/getMaintenanceInfo/${selectedDevice.value}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({})
        })
            .then(response => {
                return checkStatus(response)
            })
            .then(data => {
                let objList = []
                data.RESULT_DATA.map((obj, key) => {
                    objList.push(obj.ma_list);
                });

                let objList2 = []
                data.RESULT_DATA.map((obj, key) => {
                    objList2.push(obj.alert_history);
                });

                this.setState({
                    maintenanceInfoList: objList[0] || [],
                    alertHistory: objList2[0] || []
                });
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });

    }

    onClickUseTemplate = (selectedTemplate) => {
        const { templateList } = this.state;
        // console.log('selectedTemplate:', selectedTemplate);
        let maTemplate = [];
        if (selectedTemplate.value > 0){
            maTemplate = filter(templateList, (n) => n.template_id === selectedTemplate.value);
            this.setState({ maintenanceInfoList: [] }, () => this.setState({ maintenanceInfoList: maTemplate[0].ma_list}));
        }
    }

    onChangeSelectedMeasure = (e, index) => {
        const { measureTypeList, maintenanceInfoList } = this.state;
        const values = e.target.value;
        let maUnit = [];
        if (values.length > 0) {
            maUnit = filter(measureTypeList, (n) => n.measureTypeName === values);
            // console.log('maUnit:', maUnit);
            maintenanceInfoList[index].measure_unit = maUnit[0].measureUnit;
            this.setState({maintenanceInfoList});
        }
        maintenanceInfoList[index].measure_type_id = maUnit[0].measure_type_id;
        this.setState({maintenanceInfoList});
    }

    onChangeMaName = (data, index) => {
        const { maintenanceInfoList } = this.state;
        maintenanceInfoList[index].ma_name = data;
        this.setState({maintenanceInfoList});
    }

    onChangeAlertRepeat = (data, index) => {
        const { maintenanceInfoList } = this.state;
        maintenanceInfoList[index].alert_repeat = data;
        maintenanceInfoList[index].next_alert_when = maintenanceInfoList[index].alert_repeat - maintenanceInfoList[index].counter
        this.setState({maintenanceInfoList});
    }

    onClickAddMaList = () => {
        const { maintenanceInfoList, carLicenceNo, maList } = this.state;
        const ma = {
                ma_name: '',
                measure_type_id: 4,
                alert_repeat: 0,
                is_email_alert: false,
                is_line_alert: false,
                counter: 0,
                next_alert_when: '',
                ma_list_id: ''
        }
        maintenanceInfoList.push(ma);
        this.setState({maintenanceInfoList});
    }

    onClickDeleteRow(key) {
        const { maintenanceInfoList } = this.state;
        const maintenanceInfoListObj = maintenanceInfoList;

        maintenanceInfoListObj.splice(key, 1);
        this.setState({ maintenanceInfoList: [] }, () => this.setState({ maintenanceInfoList: maintenanceInfoListObj }));
    }

    onChangeCounter = (data, index) => {
        const { maintenanceInfoList } = this.state;
        maintenanceInfoList[index].counter = data;
        maintenanceInfoList[index].next_alert_when = maintenanceInfoList[index].alert_repeat - maintenanceInfoList[index].counter
        this.setState({maintenanceInfoList});
    }

    onChangeMailAlert = (data, index) => {
        const { maintenanceInfoList } = this.state;
        maintenanceInfoList[index].is_email_alert = data;
        this.setState({maintenanceInfoList});
    }

    onChangeLineAlert = (data, index) => {
        const { maintenanceInfoList } = this.state;
        maintenanceInfoList[index].is_line_alert = data;
        this.setState({maintenanceInfoList});
    }

    onClickSubmit = () => {
        const { maintenanceInfoList, carLicenceNo, device_no } = this.state;

        const {
            user_name,
            user_id,
            token
        } = this.props;
        let maintenanceInfoLists = []
            maintenanceInfoList.map((obj, key) => {
                delete obj.measure_unit
                delete obj.measure_type
                delete obj.is_alert
                delete obj.last_alert_dtm
                maintenanceInfoLists.push(obj);
        });
        if (carLicenceNo) {
            AlertConfirm("เพิ่มระบบซ่อมบำรุง", "คุณต้องการบันทึกข้อมูลหรือไม่").then(isOk => {
                if (isOk) {
                    fetch("http://203.150.199.244/api/admin/updateMaintenance", {
                        method: 'post',
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            // "user_id": user_id,
                            // "user_name": user_name,
                            "token": token
                        },
                        body: JSON.stringify({
                            "device_id": device_no,
                            "device_no": carLicenceNo,
                            // "ma_list": maintenanceInfoList
                            "ma_list": maintenanceInfoLists
                        })
                    })
                        .then(response => {
                            return checkStatus(response)
                        })
                        .catch(function (err) {
                            console.log('err:', err);
                            // POST failed...
                        });
                }
            });
        } else {
            alert('กรุณาเลือกป้ายทะเบียน');
        }
    }

    onClickSaveTemplate = () => {
        const { maintenanceInfoList, selectedTemplate } = this.state;
        if (maintenanceInfoList && maintenanceInfoList.length > 0 && !selectedTemplate) {
            this.setState({isSaveTemplate: true});
        } else if (maintenanceInfoList && maintenanceInfoList.length > 0 && selectedTemplate) {
            if (selectedTemplate.value > 0){
                this.onSubmitEditTemplate(selectedTemplate);
            } else {
                this.setState({isSaveTemplate: true});
            }
        } else {
            Alert('กรุณาเพิ่มรายการอย่างน้อย 1 รายการ');
        }
    }

    onSubmitNewTemplate = () => {
        const { maintenanceInfoList, templateName, selectedDevice } = this.state;
        const {
            user_name,
            user_id,
            token
        } = this.props;

        // console.log('templateName:', templateName);
        let maintenanceInfoLists = []
        maintenanceInfoList.map((obj, key) => {
            delete obj.measure_unit
            delete obj.measure_type
            delete obj.is_alert
            delete obj.last_alert_dtm
            maintenanceInfoLists.push(obj);
        });
        if(templateName && templateName.length > 0) {
            AlertConfirm("เพิ่มแม่แบบระบบซ่อมบำรุง", "คุณต้องการบันทึกข้อมูลหรือไม่").then(isOk => {
                if (isOk) {
                    fetch("http://203.150.199.244/api/admin/newMATemplate", {
                        method: 'post',
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            // "user_id": user_id,
                            // "user_name": user_name,
                            "token": token
                        },
                        body: JSON.stringify({
                            "name": templateName,
                            "ma_list": maintenanceInfoLists
                        })
                    })
                        .then(response => {
                            return checkStatus(response)
                        })
                        .then(data => {
                            if (data.RESULT_STATUS === '000') {
                                AlertCommit(true, '');
                            }
                        })
                        .then(() => this.setState({isSaveTemplate: false}))
                        .then(() => this.getMATemplateList())
                        .catch(function (err) {
                            console.log('err:', err);
                            // POST failed...
                        });
                }
            });
        } else {
            alert('กรุณาใส่ชื่อแม่แบบ');
        }

    }


    onSubmitEditTemplate = (selectedTemplate) => {
        const { maintenanceInfoList } = this.state;
        const {
            user_name,
            user_id,
            token
        } = this.props;

        let maintenanceInfoLists = []
        maintenanceInfoList.map((obj, key) => {
            delete obj.measure_unit
            delete obj.measure_type
            delete obj.is_alert
            delete obj.last_alert_dtm
            maintenanceInfoLists.push(obj);
        });
            AlertConfirm(`แก้ไขแม่แบบ ${selectedTemplate.label}` , "คุณต้องการบันทึกข้อมูลหรือไม่").then(isOk => {
                if (isOk) {
                    fetch(`http://203.150.199.244/api/admin/updateMATemplate/${selectedTemplate.value}`, {
                        method: 'post',
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            // "user_id": user_id,
                            // "user_name": user_name,
                            "token": token
                        },
                        body: JSON.stringify({
                            "name": selectedTemplate.label,
                            "ma_list": maintenanceInfoLists
                        })
                    })
                        .then(response => {
                            return checkStatus(response)
                        })
                        // .then(() => this.setState({isSaveTemplate: false}))
                        .then(data => {
                            if (data.RESULT_STATUS === '000') {
                                AlertCommit(true, '');
                            }
                        })
                        .then(() => this.setState({isSaveTemplate: false}))
                        .then(() => this.getMATemplateList())
                        .catch(function (err) {
                            console.log('err:', err);
                            // POST failed...
                        });
                }
            });
    }

    onClickDeleteTemplate = () => {
        const {
            user_name,
            user_id,
            token
        } = this.props;
        const { selectedTemplate } = this.state;

        if(selectedTemplate && selectedTemplate.label.length > 0) {
            AlertConfirm(`ลบแม่แบบ  ${selectedTemplate.label}`, "คุณต้องการบันทึกข้อมูลหรือไม่").then(isOk => {
                if (isOk) {
                    fetch(`http://203.150.199.244/api/admin/deleteMATemplate/${selectedTemplate.value}`, {
                        method: 'post',
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            // "user_id": user_id,
                            // "user_name": user_name,
                            "token": token
                        },
                        body: JSON.stringify({})
                    })
                        .then(response => {
                            return checkStatus(response)
                        })
                        .then(() => this.setState({isSaveTemplate: false, selectedTemplate: ''}))
                        .then(() => this.getMATemplateList())
                        .then(() => this.setState({maintenanceInfoList: []}))
                        .catch(function (err) {
                            console.log('err:', err);
                            // POST failed...
                        });
                }
            });
        } else {
            Alert('กรุณาเลือกแม่แบบก่อน!');
        }

    }

    render() {
        const {
            maintenanceInfoList,
            isAddAlertMA,
            selectedTemplate,
            measureTypeList,
            isSaveTemplate,
            templateList
        } = this.state;
        const { onClickAddAlertMA } = this.props;

        let templateLoop;
        const templateLists = map(templateList, (data) => {
            templateLoop = {
                value: data.template_id,
                label: data.name
            };
            return templateLoop;
        });

        return(
            <div className="gray-panel" >
                <div className="card">
                    <div className="card-header">
                        <h5 style={{paddingLeft: '1em'}}>
                            <i
                                onClick={onClickAddAlertMA}
                                className="fa fa-arrow-left"
                                aria-hidden="true"
                                style={{color: '#7386D5',cursor: 'pointer'}} />
                            {isAddAlertMA ? 'เพิ่ม' : 'แก้ไข'}รายการแม่แบบ
                        </h5>
                    </div>
                        <div className="card-body">

                            <div className="col-md-12">
                                <h1 className="page-header">
                                    <i style={{color: '#7386D5'}}>{'เลือกรายการแม่แบบ'}</i>
                                </h1>
                            </div>
                            <hr/>
                            <div className="row">
                                <div className="col-md-6 row">
                                    <div className="col-md-8 row">
                                        <div className="col-md-8" style={{fontSize: '14px'}}>
                                            <Select
                                                value={selectedTemplate}
                                                onChange={this.handleChangeTemplate}
                                                options={templateLists}
                                                placeholder={'เลือกจาก Template'}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <button
                                                type="button"
                                                className="fas fa-search btn btn-info"
                                                style={{ width: '48px', height: '36px' }}
                                                onClick={() => {this.setState({maintenanceInfoList: []}), this.onClickUseTemplate(selectedTemplate)}}
                                            />
                                            {' '}
                                            <button
                                                className="btn btn-danger btn-xs"
                                                data-title="Delete"
                                                data-toggle="modal"
                                                data-backdrop="static"
                                                data-keyboard="false"
                                                onClick={this.onClickDeleteTemplate}>
                                                <span className="fa fa-trash" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className=" mx-auto">
                                <div className="col-md-12 table-responsive">
                                    <div style={{textAlign:'right'}}>
                                        <button className="btn btn-info btn-xs" onClick={() => this.onClickAddMaList()} ><span className="fa fa-plus" /></button>
                                    </div>
                                    <table className="table table-bordred table-striped table-hover " style={{fontSize: '14px'}}>
                                        <thead >
                                            <tr>
                                                <th rowSpan={2} style={{width:'20px'}}>#</th>
                                                <th rowSpan={2} style={{width:'150px', textAlign: 'center'}}>รายการ</th>
                                                <th rowSpan={2} style={{width:'150px', textAlign: 'center'}}>วัดตาม</th>
                                                <th rowSpan={2} style={{width:'80px', textAlign: 'center'}}>แจ้งทุกๆ</th>
                                                <th rowSpan={2} style={{width:'30px'}}></th>
                                                <th rowSpan={2} style={{width:'120px', textAlign: 'center'}}>ค่าปัจจุบัน</th>
                                                <th rowSpan={2} style={{width:'30px'}}></th>
                                                <th rowSpan={2} style={{width:'120px', textAlign: 'center'}}>เตือนเมื่อถึง</th>
                                                <th rowSpan={2} style={{width:'30px'}}></th>
                                                <th colSpan={2}>เตือนด้วย</th>
                                                <th rowSpan={2} style={{width:'50px', textAlign: 'right'}}></th>

                                            </tr>
                                            <tr>
                                                <th style={{width:'50px'}}>Mail</th>
                                                <th style={{width:'50px'}}>Line</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        { maintenanceInfoList &&
                                            maintenanceInfoList.map((data, key) => {
                                                return (
                                                    <tr key={key}>
                                                        <td>{key + 1}</td>
                                                        <td>
                                                            <input
                                                                style={{background: 'rgba(255,255,255,0.4)', border:'none', textAlign: 'center'}}
                                                                name="maName"
                                                                className="form-control"
                                                                type="text"
                                                                defaultValue={data.ma_name}
                                                                onChange={(e) => this.onChangeMaName(e.target.value, key)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <select
                                                                name="measureType"
                                                                className="form-control"
                                                                defaultValue={maintenanceInfoList[key].measure_type}
                                                                onChange={(e) => this.onChangeSelectedMeasure(e, key)}>
                                                                {
                                                                    measureTypeList.map((item) => {
                                                                        return(
                                                                            <option
                                                                                    key={item.measure_type_id}
                                                                                    name={item.measureTypeName}>
                                                                                {item.measureTypeName}
                                                                            </option>
                                                                        )
                                                                    })
                                                                }
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <input
                                                                style={{background: 'rgba(255,255,255,0.4)', border:'none', textAlign: 'center'}}
                                                                name="alertRepeat"
                                                                className="form-control"
                                                                type="text"
                                                                defaultValue={maintenanceInfoList[key].alert_repeat}
                                                                onBlur={(e) => this.onChangeAlertRepeat(e.target.value, key)}
                                                            />
                                                        </td>
                                                        <td>
                                                           {maintenanceInfoList[key].measure_unit || 'วัน'}
                                                        </td>
                                                        <td>
                                                            <input
                                                                style={{background: 'rgba(255,255,255,0.4)', border:'none',  textAlign: 'center'}}
                                                                name="counter"
                                                                className="form-control"
                                                                type="text"
                                                                defaultValue={maintenanceInfoList[key].counter}
                                                                onBlur={(e) => this.onChangeCounter(e.target.value, key)}
                                                            />
                                                        </td>
                                                        <td>
                                                            {maintenanceInfoList[key].measure_unit || 'วัน'}
                                                        </td>
                                                        <td>
                                                            <input
                                                                style={{background: 'rgba(255,255,255,0.4)', border:'none',  textAlign: 'center'}}
                                                                name="nextAlertWhen"
                                                                className="form-control"
                                                                type="text"
                                                                disabled
                                                                value={maintenanceInfoList[key].next_alert_when}
                                                            />
                                                        </td>
                                                        <td>
                                                            {maintenanceInfoList[key].measure_unit || 'วัน'}
                                                        </td>
                                                        <td>
                                                            <input
                                                                name="mailAlert"
                                                                className="form-control"
                                                                type="checkbox"
                                                                defaultChecked={maintenanceInfoList[key].is_email_alert}
                                                                onChange={(e) => this.onChangeMailAlert(e.target.checked, key)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                name="lineAlert"
                                                                className="form-control"
                                                                type="checkbox"
                                                                defaultChecked={maintenanceInfoList[key].is_line_alert}
                                                                onChange={(e) => this.onChangeLineAlert(e.target.checked, key)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <button
                                                                className="btn btn-danger btn-xs"
                                                                data-title="Delete"
                                                                data-toggle="modal"
                                                                data-backdrop="static"
                                                                data-keyboard="false"
                                                                onClick={() => this.onClickDeleteRow(key)}>
                                                                <span className="fa fa-trash" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="row">
                                    <div>
                                        <button
                                            type="button"
                                            className="btn btn-warning"
                                            id="btsave-template"
                                            onClick={() => this.onClickSaveTemplate()}>
                                            <i className="fa fa-fw fa-plus" /> บันทึก
                                        </button>
                                    </div>
                            </div>
                        </div>
                </div>
                { isSaveTemplate &&
                <div className="modal-confirm" style={{display:'block'}} >
                    <div className="modal-dialog modal-dialog-centered" style={{top: -200}}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title custom_align" id="Heading">
                                    <i className="fa fa-cog fa-fw"></i>
                                    {' บันทึกแม่แบบ'}
                                </h4>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-hidden="true"
                                    style={{padding: 0, margin: 0, position: 'inherit'}}
                                    onClick={() => this.setState({isSaveTemplate: false})}>
                                    <span className="fa fa-times" aria-hidden="true" />
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group row">
                                    <label htmlFor="example-text-input " className="col-md-3 text-right" >ชื่อแม่แบบ</label>
                                    <div className="col-md-9">
                                        <input
                                            className="form-control"
                                            type="text"
                                            id="name"
                                            // defaultValue={alert}
                                            onChange={(e) => this.setState({ templateName: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer ">
                                <button className="btn btn-primary" onClick={() => this.onSubmitNewTemplate()} >บันทึก</button>
                                <button className="btn btn-danger" onClick={() => this.setState({isSaveTemplate: false})}>ยกเลิก</button>
                            </div>
                        </div>

                    </div>
                </div>
                }
            </div>
        );
    }
}
// MaintenanceSummary.defaultProps = {
//     deviceSelected:{},
//     deviceInfo:{},
// }
//
MaintenanceTemplate.propTypes = {
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    isAddAlertMA: PropTypes.bool.isRequired,
    // onClickAddAlertMA: PropTypes.func.isRequired
}

export default MaintenanceTemplate;



// WEBPACK FOOTER //
// ./src/app/view/components/Maintenance/MaintenanceTemplate.js